module.exports = __webpack_public_path__ + "img/exclusive-design.0d472ce.svg";